import { useEffect, useState } from 'react'
import { Keyboard } from 'react-native'

export const useKeyboardState = () => {
  const [keyboardHeight, setKeyboardHeight] = useState(0)

  useEffect(() => {
    const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', onKeyboardDidShow)
    const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', onKeyboardDidHide)

    return () => {
      keyboardDidShowListener.remove()
      keyboardDidHideListener.remove()
    }
  }, [])

  const onKeyboardDidShow = (e: any) => {
    setKeyboardHeight(e.endCoordinates.height)
  }

  const onKeyboardDidHide = () => {
    setKeyboardHeight(0)
  }

  return {
    isVisible: keyboardHeight !== 0,
    height: keyboardHeight,
  }
}
